<template>
  <div ref="container">
    <div class="coupon-list" v-if="couponsList.length > 0">
      <div
        class="item acea-row row-center-wrapper norestriction"
        v-cloak
        v-for="(item, index) in couponsList"
        :key="index"
      >
        <div class="money" :class="item._type === 0 ? 'moneyGray' : ''">
          <div>
            <span class="num"
              >{{ item.couponPrice
              }}<span class="co-integral" v-if="item.couponType === 1"
                >积分</span
              ><span class="co-integral" v-else>折</span>
            </span>
          </div>
          <div class="pic-num" v-if="item.condition > 0">
            满{{ item.condition
            }}<span v-if="item.conditionType === 1">积分</span
            ><span v-else>件</span>可用
          </div>
          <div class="pic-num" v-else>
            无门槛
          </div>
        </div>
        <div class="text">
          <div class="condition line1">
            {{ item.couponTitle }}
          </div>
          <div class="data acea-row row-between-wrapper">
            <div v-if="startUsing(item)">有效期至 {{ item.endTime }}</div>
            <div v-else>
              <div>
                {{ item.startTime }}
              </div>
              <div>
                {{ item.endTime }}
              </div>
            </div>
            <div class="bnt bg-color-red" @click="toUse(item.id, index)">
              去使用
            </div>
          </div>
          <div class="data2">
            <div v-if="item.sharePreferential" class="acea-row">
              <span v-if="item.sharePreferential.indexOf('优惠券') >= 0"
                >可叠加使用<span v-if="item.sharePreferential !== '优惠券'"
                  >，</span
                ></span
              >
              <span
                v-if="
                  item.sharePreferential.indexOf('限时折扣') >= 0 &&
                    item.sharePreferential.indexOf('满减/送') >= 0
                "
                >可与限时折扣、满减活动同享</span
              >
              <span v-else-if="item.sharePreferential.indexOf('限时折扣') >= 0"
                >可与限时折扣活动同享</span
              >
              <span v-else-if="item.sharePreferential.indexOf('满减/送') >= 0"
                >可与满减活动同享</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--暂无优惠券-->
    <div
      class="noCommodity"
      v-if="couponsList.length === 0 && loading === true"
    >
      <div class="noPictrue">
        <img src="@assets/images/noCoupon.png" class="image" />
      </div>
    </div>

    <div class="coupon-list-footer">
      <div style="height:1.2rem"></div>
      <div class="footer acea-row row-between-wrapper">
        <router-link to="/user/user_usage_record" class="ritem first">
          <div>优惠券使用记录</div>
        </router-link>
        <router-link to="/user/coupon_center" class="ritem">
          <div>领券中心</div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { getCouponsUser } from "@api/user";
import { dataFormatT } from "@utils";
const NAME = "UserCoupon";

export default {
  name: "UserCoupon",
  components: {},
  props: {},
  data: function() {
    return {
      couponsList: [],
      loading: false,
      where: {
        status: 1,
        sort: "createTime"
      }
    };
  },
  watch: {
    $route: function(n) {
      var that = this;
      if (n.name === NAME) {
        that.getUseCoupons();
      }
    }
  },
  mounted: function() {
    this.getUseCoupons();
  },
  methods: {
    dataFormatT,
    getUseCoupons: function() {
      let that = this;
      getCouponsUser(that.where).then(res => {
        that.couponsList = res.data;
        that.loading = true;
      });
    },
    toUse(id, index) {
      this.$router.push({ path: "/goods_list" });
    },
    startUsing(item) {
      return new Date(item.startTime).getTime() <= new Date().getTime();
    }
  }
};
</script>
